import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgLink = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M3.95 6.95A2.9 2.9 0 0 1 6 6.1h5a.9.9 0 0 1 0 1.8H6A1.1 1.1 0 0 0 4.9 9v9A1.1 1.1 0 0 0 6 19.1h9a1.1 1.1 0 0 0 1.1-1.1v-5a.9.9 0 1 1 1.8 0v5a2.9 2.9 0 0 1-2.9 2.9H6A2.9 2.9 0 0 1 3.1 18V9a2.9 2.9 0 0 1 .85-2.05"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M20.636 3.364a.9.9 0 0 1 0 1.272l-10 10a.9.9 0 1 1-1.272-1.272l10-10a.9.9 0 0 1 1.272 0"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M14.1 4a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 .9.9v5a.9.9 0 0 1-1.8 0V4.9H15a.9.9 0 0 1-.9-.9"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLink;
